import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { ImageUpload } from "./ImageUpload";

const GROUPS = [
  {
    title: "Hero (Bagian Atas)",
    fields: [
      { key: "hero_badge", label: "Badge / Nama Naungan", type: "text" },
      { key: "hero_title", label: "Judul Utama", type: "textarea" },
      { key: "hero_highlight", label: "Kata Highlight (Emas)", type: "text" },
      { key: "hero_highlight2", label: "Kata Highlight (Cyan)", type: "text" },
      { key: "hero_subtitle", label: "Sub-judul", type: "textarea" },
      { key: "hero_image", label: "Gambar Latar Hero", type: "image" },
    ],
  },
  {
    title: "Tentang Kami",
    fields: [
      { key: "about_heading", label: "Judul About", type: "textarea" },
      { key: "about_paragraph", label: "Paragraf About", type: "textarea" },
      { key: "about_image", label: "Gambar About", type: "image" },
    ],
  },
  {
    title: "Kontak & WhatsApp",
    fields: [
      { key: "contact_address", label: "Alamat", type: "text" },
      { key: "contact_email", label: "Email", type: "text" },
      { key: "contact_phone", label: "Telepon", type: "text" },
      { key: "whatsapp_number", label: "Nomor WhatsApp Admin (format 62...)", type: "text" },
      { key: "map_embed", label: "Google Maps (alamat / koordinat / URL embed)", type: "text" },
    ],
  },
  {
    title: "Media Sosial (URL)",
    fields: [
      { key: "social_instagram", label: "Instagram URL", type: "text" },
      { key: "social_linkedin", label: "LinkedIn URL", type: "text" },
      { key: "social_twitter", label: "Twitter/X URL", type: "text" },
      { key: "social_youtube", label: "YouTube URL", type: "text" },
    ],
  },
];

export const SettingsPanel = () => {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/settings/site").then((r) => setS(r.data || {})).catch((e) => toast.error(apiErr(e)));
  }, []);

  const set = (k) => (v) => setS((p) => ({ ...p, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", s);
      toast.success("Pengaturan tersimpan");
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setSaving(false);
    }
  };

  if (!s) return <div className="py-20 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-cyan" /></div>;

  const input = "mt-2 w-full rounded-lg bg-navy-soft border border-white/10 px-3 py-2.5 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan/50";

  return (
    <div data-testid="panel-settings">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading font-bold text-2xl">Konten & Kontak</h2>
        <button onClick={save} disabled={saving} data-testid="save-settings" className="inline-flex items-center gap-2 rounded-full bg-gold px-6 py-2.5 text-sm font-bold text-navy hover:shadow-[0_0_24px_rgba(212,175,55,0.4)] disabled:opacity-60">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Simpan Semua
        </button>
      </div>

      <div className="space-y-8">
        {GROUPS.map((g) => (
          <div key={g.title} className="rounded-2xl border border-white/10 bg-navy-card/50 p-6">
            <h3 className="font-heading font-semibold text-lg mb-5 text-gold">{g.title}</h3>
            <div className="grid md:grid-cols-2 gap-5">
              {g.fields.map((f) => (
                <div key={f.key} className={f.type === "image" || f.type === "textarea" ? "md:col-span-2" : ""}>
                  {f.type === "image" ? (
                    <ImageUpload label={f.label} value={s[f.key]} onChange={set(f.key)} testid={`settings-${f.key}`} />
                  ) : f.type === "textarea" ? (
                    <>
                      <label className="text-sm text-slate-300 font-medium">{f.label}</label>
                      <textarea rows={2} value={s[f.key] || ""} onChange={(e) => set(f.key)(e.target.value)} className={`${input} resize-none`} data-testid={`settings-${f.key}`} />
                    </>
                  ) : (
                    <>
                      <label className="text-sm text-slate-300 font-medium">{f.label}</label>
                      <input value={s[f.key] || ""} onChange={(e) => set(f.key)(e.target.value)} className={input} data-testid={`settings-${f.key}`} />
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
